import CalculatedConcurrentUsers from 'shared/components/calculated_concurrent_users';
import NativeComponentInitializers from 'shared/native_component_initializers';
import RequireLoginModal from "desktop/components/require_login_modal";
import DiscussionItem from 'shared/components/discussion_item';
import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
import Page from 'shared/components/page';
import Env from 'shared/env';
import WebSocketConnection from 'shared/components/live/web_socket_connection';
import { CHANNEL_CHAT } from 'shared/components/live/web_socket_channel';
import SocketAPI from 'vidio-chat';

export default class Discussion {
  constructor() {
    this.wait = 5000;
    this.userPresenceCount = 0;
    this.firstRun = true;
    this.maxItem = 100;
    this.emptyClass = 'livestreaming-discussion__content--empty';
    this.calculatedConcurrentUsers = { setConcurrentUserCount: function(){} };
    this.lsIsEnded = false;
    this.isFullscreen = false;
    this.scrollBeforeTopFlag = true;
    this.scrollTopFlag = true;

    this.pinnedMessageDate = null;
    this.urlRegex = new RegExp("(https?://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?");

    this.ui = {
      container:       '.livestreaming-discussion__container',
      content:         '.livestreaming-discussion__content',
      form:            '.livestreaming-discussion__form',
      input:           '.livestreaming-discussion__input',
      submitButton:    '.livestreaming-discussion__submit',
      submitIcon:      '.livestreaming-discussion__submit-icon',
      submitIconActive:'.livestreaming-discussion__submit-icon--active',
      emojiTable:      '.livestreaming-discussion__table-button__img',
      item:            '.livestreaming-discussion-item',
      itemWithId:      '.livestreaming-discussion-item[data-id]',
      lastItemJoined:  '.livestreaming-discussion-item__joined:last-child',
      metaCurrentUser: 'meta[name=current-username]',
      metaLanguage:    'meta[name=language]',
      calculatedConcurrentUsers: '[data-component=CalculatedConcurrentUsers]',
      pinnedMessageDisplay: '.livestreaming-discussion__pinned-message-display',
      pinnedMessageDisplayTimestamp: '.livestreaming-discussion__pinned-message-display__timestamp',
      pinnedMessageDisplayUsername: '.livestreaming-discussion__pinned-message-display__username',
      pinnedMessageDisplayContent: '.livestreaming-discussion__pinned-message-display__content',
      pinnedMessageDetailContainer: '.livestreaming-discussion__pinned-message-detail-container',
      pinnedMessageDetailOverlay: '.livestreaming-discussion__pinned-message-detail-overlay',
      pinnedMessageDetailIgnoreButton: '.livestreaming-discussion__pinned-message-detail-ignore-button',
      pinnedMessageDetailFull: '.livestreaming-discussion__pinned-message-detail-full',
      pinnedMessageDetailPreview: '.livestreaming-discussion__pinned-message-detail-preview',
      pinnedMessageDetailPreviewImage: '.livestreaming-discussion__pinned-message-detail-preview-image',
      pinnedMessageDetailPreviewTitle: '.livestreaming-discussion__pinned-message-detail-preview-title',
      pinnedMessageDetailCloseButton: '.livestreaming-discussion__pinned-message-detail-close-button',
      pinnedMessageDetailTimestamp: '.livestreaming-discussion__pinned-message-detail__timestamp',
      pinnedMessageDetailUsername: '.livestreaming-discussion__pinned-message-detail__username',
    };

    let joinWording = {
      en: 'people joined',
      id: 'bergabung'
    };

    this.$current_username = $(this.ui.metaCurrentUser).attr('content');
    this.selectedJoinWording = joinWording[$(this.ui.metaLanguage).attr('content')];

    if(!VidioHelpers.isMobile()) {
      this.modal = new RequireLoginModal({ element: this.ui.input });
    }

    this.isLoggedIn = false;

    this.wsDOM = $('.js-component[data-component="WebSocketConnection"]')[0];
  }

  init() {
    this.bindPinnedMessageDisplay();
    this.bindBeforeSend();
    this.bindSuccessForm();
    this.bindLiveChatScrollEvent();
    this.listenOnChangeInput();
    this.bindLoginPopupTracker();
    this.requestChatMessage();

    $(window).on('load', function() {
      this.bindFullscreenEvent();
    }.bind(this));

    $(document).on('visibilitychange', function() {
      this.scrollWhenWindowVisible();
    }.bind(this));
  }

  isWebSocketAvailable() {
    return 'WebSocket' in window && window.WebSocket.CLOSING === 2;
  }

  requestChatMessage() {
    if(this.isWebSocketAvailable()) {
      const token = JSON.parse(sessionStorage.getItem('token')) || {};
      $('#comment_token').val(token.web);

      WebSocketConnection.runWhenOpen(this.subscribeToChat.bind(this));
      this.requestMessagesThenRender(token.web);
    } else {
      this.load();
    }
  }

  subscribeToChat() {
    const isToggleOn = this.wsDOM.dataset.useNewConnection === 'true';

    if (isToggleOn) {
      const channelChat = CHANNEL_CHAT(Page.id());
      SocketAPI.subscribe(channelChat);
      SocketAPI.request(channelChat, 'get-pin-message');
    } else {
      SocketAPI.sendMessage({ act: 'subscribe' });
      SocketAPI.sendMessage({ act: 'check-pinned-message' });
    }
  }

  getIdOfPathname(pathname) {
    var tempPos = pathname.indexOf("/");
    var start = pathname.indexOf("/", tempPos + 1);
    var end = pathname.length;
    if (pathname.indexOf("-") !== -1) {
      end = pathname.indexOf("-");
    }

    return pathname.substring(start, end);
  }

  bindLoginPopupTracker() {
    $(`${this.ui.input}, ${this.ui.emojiTable}, ${this.ui.submitButton}`).on('click', function(event) {
      if(!this.isUserLoggedIn()) {
        if (this.isEmojiTableClicked(event)) {
          event.stopPropagation();
        }

        if(VidioHelpers.isMobile()) {
          this.redirectToLogin();
        } else {
          this.modal.onClick(event);
        }
      } else {
        const livestreaming_id = Page.id();
        AhoyEvent.send("VIDIO::CHAT", { action: "click", livestreaming_id: livestreaming_id });
      }
    }.bind(this));
  }

  isUserLoggedIn() {
    return Object.keys(window.currentUser).length > 0;
  }

  redirectToLogin() {
    window.location.href = $(this.ui.input).data('url');
  }

  isEmojiTableClicked(event) {
    var className = this.ui.emojiTable.substring(1, this.ui.emojiTable.length);
    return $(event.target).hasClass(className);
  }

  params(data) {
    return $.extend({ commentable_id: Page.id(), commentable_type: Page.type() }, data);
  }

  request(data, callback) {
    var params = this.params();
    $.ajax({
      method: 'GET',
      url: '/live/' + params.commentable_id + '/comments.json',
      dataType: 'json',
      data: data,
    })
    .done(callback.bind(this))
    .always(this.run.bind(this));
  }

  getMessageUrl() {
    const NUMBER_OF_MESSAGE = 100;
    const origin = `${Env.vidioChatSecure() ? 'https' : 'http'}://${Env.vidioChatHost()}`;
    return `${origin}/conversations/${Page.id()}/messages/${NUMBER_OF_MESSAGE}`; 
  }

  requestMessages(token) {
    return $.ajax({
      method: 'GET',
      url: this.getMessageUrl(),
      dataType: 'json',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Platform': 'browser',
      },
    });
  }

  requestMessagesThenRender(token) {
    return this.requestMessages(token)
      .done(payload => {
        this.loadSuccess({ comments: payload});
      })
      .fail(err => {
        window.console.error(`Error render messages: ${err}`);
      });
  }

  load() {
    this.request({}, this.loadSuccess);
  }

  run() {
    if(!this.isFullscreen && !this.lsIsEnded) {
      setTimeout(function(){
        this.request({}, this.runSuccess);
      }.bind(this), this.wait);
    }
  }

  bindFullscreenEvent() {
    const bindEvent = setInterval(function() {
      try {
        window.player.tech().on("fullscreenchange", this.checkFullscreen.bind(this));
        clearInterval(bindEvent);
      } catch(e) {
        console.error('CatchedFullSceenPlayerChanged', e);
      }
    }.bind(this), 400);
  }

  _getContainerHeight() {
    return $(this.ui.container).height();
  }

  _getLivestreamingBannerHeight() {
    return $('.b-livestreaming-banner').length ? $('.b-livestreaming-banner').height() : 0;
  }

  _getContainerScrollTop() {
    return $(this.ui.container).scrollTop();
  }

  bindLiveChatScrollEvent() {
    $(this.ui.container).on('scroll', function() {
      var containerScrollTop = this._getContainerScrollTop();
      var containerHeight = this._getContainerHeight();
      var contentHeight = this.height();
      var percentage = containerScrollTop / (contentHeight - containerHeight) * 100.0;

      if (contentHeight > containerHeight) {
        if (!this.scrollTopFlag) {
          if (containerScrollTop === 0) {
            this.sendAhoyEvent('top', 'scroll');
            this.scrollTopFlag = true;
          }
        }

        if (!this.scrollBeforeTopFlag) {
          if (containerScrollTop > 0 && percentage <= 25.0) {
            this.sendAhoyEvent('before-top', 'scroll');
            this.scrollBeforeTopFlag = true;
          }
        }

        if (percentage > 50.0) {
          this.scrollBeforeTopFlag = false;
          this.scrollTopFlag = false;
        }
      }
    }.bind(this));
  }

  checkFullscreen() {
    if (window.player.tech().plugin().instance().isFullscreen()) {
      if (this.isFullscreen === false) {
        this.sendAhoyEvent('open', 'fullscreen');
      }

      this.isFullscreen = true;
    } else {
      if (this.isFullscreen === true) {
        this.sendAhoyEvent('close', 'fullscreen');
      }

      this.isFullscreen = false;
      this.run();
    }
  }

  stop() {
    clearInterval(this.process);
    this.process = null;
  }

  initExternalComponent() {
    if($(this.ui.calculatedConcurrentUsers).length > 0) {
      this.calculatedConcurrentUsers = new CalculatedConcurrentUsers({element: document.querySelector(this.ui.calculatedConcurrentUsers)});
    }
  }

  loadSuccess(data) {
    this.initExternalComponent();

    if (data.comments.length === 0) {
      this.addBackground();
    } else {
      var comments = data.comments;
      this.addCollection(comments);
      this.scroll();
    }
  }

  runSuccess(data) {
    this.calculatedConcurrentUsers.setConcurrentUserCount(data);

    this.lsIsEnded = data.livestreaming_ended;
    this.wait = data.livechat_interval * 1000;

    if (data.comments.length > 0) {
      this.removeBackground();

      var comments = data.comments.reverse();
      this.addCollection(comments);
    }

    this.addUserJoin(data.user_presence_count);
    this.firstRun = false;
  }

  bindPinnedMessageDisplay() {
    $(this.ui.pinnedMessageDisplay).click(this.showPinnedMessageDetail.bind(this));
    $(this.ui.pinnedMessageDetailCloseButton).click(this.hidePinnedMessageOverlay.bind(this));
    $(this.ui.pinnedMessageDetailIgnoreButton).click(this.ignorePinnedMessageDisplay.bind(this));
    $(this.ui.pinnedMessageDetailContainer).click(this.sendDetailContainerEvent.bind(this));
  }

  sendDetailContainerEvent(e) {
    if (e.target.href != undefined) {
      this.sendAhoyPinnedMessageEvent('click', e.target.href);
      window.open(e.target.href, '_blank');
      return false;
    }
  }

  showPinnedMessageOverlay() {
    let element = document.querySelector(this.ui.pinnedMessageDetailOverlay);
    if (!element) {
      return;
    }
    this.sendAhoyPinnedMessageEvent('open');
    element.classList.remove('hide-me');
  }

  hidePinnedMessageOverlay() {
    let element = document.querySelector(this.ui.pinnedMessageDetailOverlay);
    if (!element) {
      return;
    }
    this.sendAhoyPinnedMessageEvent('close');
    element.classList.add('hide-me');
  }

  togglePinnedMessageDetailOverlay() {
    $(this.ui.pinnedMessageDetailOverlay).toggleClass('hide-me');
  }

  ignorePinnedMessageDisplay() {
    this.sendAhoyEvent('ignore', 'pinned-message');
    this.togglePinnedMessageDetailOverlay();
    this.hidePinnedMessageDisplay();
  }

  showPinnedMessageDetail(e) {
    if(e.target.href !== undefined) {
      this.sendAhoyPinnedMessageEvent('click', e.target.href);
      window.open(e.target.href, '_blank');
      return false;
    }

    this.showPinnedMessageOverlay();
  }

  showPinnedMessagePreview() {
    // return this.linkPreview(url).then(response => {
    //   if (typeof response.title !== 'undefined') {
    //     $(this.ui.pinnedMessageDetailPreview).removeClass('hide-me');
    //     $(this.ui.pinnedMessageDetailPreviewImage).html('<img src="'+ response.image + '">');
    //     this.ellipsisHtmlText(response.title, $(this.ui.pinnedMessageDetailPreviewTitle), 75);
    //   } else {
    //     $(this.ui.pinnedMessageDetailPreview).addClass('hide-me');
    //   }
    // });
  }

  bindBeforeSend() {
    $(this.ui.form).on('ajax:beforeSend', function() {
      const content = $('input#comment_content[name="comment[content]"]').val();
      this.sendAhoyMessageEvent('click', content);
    }.bind(this));
  }

  bindSuccessForm() {
    $(this.ui.form).on('ajax:success', function(event, value) {
      let data = event.detail ? event.detail[0] : value;
      this.renderNewComment(data);
      this.sendAhoyMessageEvent('send', data.comment.content);
    }.bind(this));
  }

  renderNewComment(data) {
    const { comment } = data;

    this.removeBackground();
    this.add(comment);
    this.reset();
    this.stickerify();
    this.removeOldMessages();
    this.scroll();
  }

  linkifyMessage(originalMessage) {
    var safeEnter = originalMessage.replace(new RegExp("\n", "g"), " \n ");
    var splittedOriginalMessage = safeEnter.split(" ");
    var linkifiedMessage = "";
    var url = [];

    for(var i = 0; i < splittedOriginalMessage.length; i ++) {
      var content = splittedOriginalMessage[i];
      if(this.urlRegex.test(content)) {
        if(content.includes("http")) {
          url.push(content);
          linkifiedMessage += '<a href='+content+' target="_blank">'+ content +'</a>';
        } else {
          url.push("//" + content);
          linkifiedMessage += '<a href=//'+content+' target="_blank">'+ content +'</a>';
        }
      } else {
        linkifiedMessage += content;
      }
      linkifiedMessage += " ";
    }

    return { message: linkifiedMessage, urls: url };
  }

  renderPinnedMessage(message) {
    var date = new Date(message.created_at);
    if(this.pinnedMessageDate === null || date > this.pinnedMessageDate) {
      this.pinnedMessageDate = date;
      var messageHours = date.getHours();
      var messageMinutes = date.getMinutes();

      messageHours = messageHours > 9 ? messageHours : ("0" + messageHours);
      messageMinutes = messageMinutes > 9 ? messageMinutes : ("0" + messageMinutes);

      var displayDate = messageHours + ":" + messageMinutes;
      var displayUsername = message.user.name;

      $(this.ui.pinnedMessageDisplay).removeClass('hide-me');
      $(this.ui.pinnedMessageDisplayTimestamp).text(displayDate);
      $(this.ui.pinnedMessageDisplayUsername).text(displayUsername);

      var originalMessage = message.content;
      var result = this.linkifyMessage(originalMessage);

      if (result.message.length > 100 - displayUsername.length) {
        $(this.ui.pinnedMessageDisplayContent).html(result.message.substring(0, 100 - displayUsername.length) + '...');
      } else {
        $(this.ui.pinnedMessageDisplayContent).html(result.message);
      }

      this.renderPinnedMessageDetail(displayDate, displayUsername, result);
      this.sendAhoyPinnedMessageEvent('impression');
    }
  }

  renderPinnedMessageDetail(displayDate, displayUsername, result) {
    $(this.ui.pinnedMessageDetailPreview).addClass('hide-me');

    var pinnedMessageDetailFull = $(this.ui.pinnedMessageDetailFull);
    $(this.ui.pinnedMessageDetailTimestamp).text(displayDate);
    $(this.ui.pinnedMessageDetailUsername).text(displayUsername);

    if (result.urls.length > 0) {
      this.showPinnedMessagePreview(result.urls[0]);
    }

    pinnedMessageDetailFull.html(result.message);
  }

  ellipsisHtmlText(message, selector, maxHeight) {
    selector.html(message);
    var ellipsisMessage = message;
    var height = selector.outerHeight();
    while (/\s/.test(ellipsisMessage) && height > maxHeight) {
      ellipsisMessage = ellipsisMessage.replace(/(\s<a.*a>)?\w*\s\S*$/, '...');
      selector.html(ellipsisMessage);
      height = selector.outerHeight();
    }
  }

  renderIncomingWsMessage(message) {
    if(message === null) {
      return;
    }

    if(message.type !== undefined && message.type == "pin") {
      this.renderPinnedMessage(message);
    } else if(message.type !== undefined && message.type == "chat/pin") {
      this.renderPinnedMessage(message);
    } else if (message.type !== undefined && message.data !== undefined && message.type === 'get-pin-message') {
      const data = JSON.parse(message.data)
      this.renderPinnedMessage(data);
    } else if (message.type == "unpin") {
      this.hidePinnedMessageDisplay();
    } else if (message.id !== undefined && message.type !== "pin") {
      this.removeBackground();
      if(this.isScrollAtBottom()) {
        this.scroll();
      }
      this.add(message);
      this.removeOldMessages();
      this.stickerify();
    }

    this.firstRun = false;
  }

  hidePinnedMessageDisplay() {
    $(this.ui.pinnedMessageDisplay).addClass('hide-me');
  }

  sendAhoyPinnedMessageEvent(action, content) {
    if (content == undefined) {
      let contentEl = document.querySelector('.livestreaming-discussion__pinned-message-detail-full');
      if (contentEl) {
        content = contentEl.innerHTML;
      }
    }
    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      feature: 'pinned message',
      livestreaming_id: this.params().commentable_id,
      section: 'chat',
      content: content
    });
  }

  sendAhoyEvent(action, feature) {
    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      feature: feature,
      livestreaming_id: this.params().commentable_id
    });
  }

  sendAhoyMessageEvent(action, content) {
    const variant = Number($('footer.livestreaming-discussion__footer').attr('data-variant'));

    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      content: content,
      livestreaming_id: this.params().commentable_id,
      variant: variant
    });
  }

  removeOldMessages() {
    var $item = $(this.ui.item);
    var currentTotalItem = $item.length;

    if (currentTotalItem > this.maxItem) {
      var delta = currentTotalItem - this.maxItem;
      $item.slice(0, delta).remove();
    }
  }

  addBackground() {
    $(this.ui.content).addClass(this.emptyClass);
  }

  removeBackground() {
    $(this.ui.content).removeClass(this.emptyClass);
  }

  add(comment) {
    if ($(this.ui.item +'[data-id="' + comment.id + '"]').length === 0) {
      const item = DiscussionItem.new(comment, this.$current_username);
      $(this.ui.content).append(item.html);
    }
  }

  addCollection(comments) {
    for (var i in comments) {
      var comment = comments[i];
      this.add(comment);
    }
    this.removeOldMessages();
    this.stickerify();
  }

  reset() {
    $(this.ui.input).val('');
  }

  height() {
    return $(this.ui.content).height();
  }

  scroll() {
    $(this.ui.container).animate({ scrollTop: this.height() });
  }

  scrollWhenWindowVisible() {
    if (! document.hidden) { this.scroll(); }
  }

  isScrollAtBottom() {
    var container = $(this.ui.container);
    return (container.prop('offsetHeight') + container.prop('scrollTop')) == container.prop('scrollHeight');
  }

  stickerify() {
    new NativeComponentInitializers();
  }

  addUserJoin(dataUserPresenceCount) {
    if((dataUserPresenceCount > this.userPresenceCount) && !this.firstRun) {
      $(this.ui.lastItemJoined).remove();

      var peopleJoined = dataUserPresenceCount - this.userPresenceCount;
      $(this.ui.content).append('<div class="livestreaming-discussion-item livestreaming-discussion-item__joined">' +  peopleJoined + ' ' + this.selectedJoinWording + '</div>');
    }
    this.userPresenceCount = dataUserPresenceCount;
  }

  windowReload() {
    window.location.reload();
  }

  listenOnChangeInput() {
    var $input = $(this.ui.input);
    var $submitIcon = $(this.ui.submitIcon);
    var $submitIconActive = $(this.ui.submitIconActive);

    $input.keyup(function() {
      if($input.val().length > 0 && $submitIconActive.length === 0) {
        $submitIcon.attr('class', 'livestreaming-discussion__submit-icon livestreaming-discussion__submit-icon--active');
      } else if ($input.val().length === 0) {
        $submitIcon.attr('class', 'livestreaming-discussion__submit-icon');
      }
    });
  }
}

